import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Portfolio API
export const portfolioAPI = {
  // Get all portfolio data
  getAll: async () => {
    const response = await axios.get(`${API}/portfolio/all`);
    return response.data;
  },
  
  // Get specific sections
  getProfile: async () => {
    const response = await axios.get(`${API}/portfolio/profile`);
    return response.data;
  },
  
  getExperience: async () => {
    const response = await axios.get(`${API}/portfolio/experience`);
    return response.data;
  }
};

// Contact API
export const contactAPI = {
  submit: async (contactData) => {
    const response = await axios.post(`${API}/contact`, contactData);
    return response.data;
  }
};

// CV API
export const cvAPI = {
  download: () => {
    // Open download in new tab
    window.open(`${API}/cv/download`, '_blank');
  },
  
  getDownloadUrl: () => {
    return `${API}/cv/download`;
  }
};

export default {
  portfolio: portfolioAPI,
  contact: contactAPI,
  cv: cvAPI
};